import {TypeAlternativePartners} from "../gameLoader/types/IGameLoader.types";

export const parseAltPartnersConfig = (config: Document): TypeAlternativePartners => {
    return Array.from(
        config.querySelectorAll("config > partners > alt")
    ).reduce((obj: TypeAlternativePartners, item) => {
        const type = item.getAttribute("type");
        const filename = item.getAttribute("filename");

        if (!type) {
            console.warn(`Alternative partner <partner><alt type="???" /> "type" attribute is empty!`);
            return obj;
        }

        if (!filename) {
            console.warn(`Alternative partner <partner><alt filename="???" /> "filename" attribute is empty!`);
            return obj;
        }

        return {
            ...obj,
            [type]: filename.replace(/.xml/, '').trim()
        }
    }, {});
};
